import type { EventDocument } from '@/features/publicsite/types/events/EventDocument';

/**
 * The two video types the store accepts (FileStorageService.ALLOWED_TYPES), and every browser the
 * site supports plays both in a native player. Anything else stays a download link.
 */
const PLAYABLE_VIDEO_TYPES: readonly string[] = ['video/mp4', 'video/webm'];

/**
 * An event's files as its page presents them (tor.md §6.11 „arhiva media (video, prezentări)”):
 * the recordings played on the page, everything else listed to download, both in the event's order.
 */
export function splitEventFiles(files: EventDocument[]): {
  videos: EventDocument[];
  downloads: EventDocument[];
} {
  const playable = (f: EventDocument) => PLAYABLE_VIDEO_TYPES.includes(f.mimeType.toLowerCase());
  return {
    videos: files.filter(playable),
    downloads: files.filter((f) => !playable(f)),
  };
}
